import React from 'react'

const QuoteIcon = React.forwardRef((props, ref) => (
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="16" fill="none" viewBox="0 0 25 16" ref={ref} {...props}>
    <path d="M19.289 0c-3.18 0-5.693 2.579-5.693 5.76 0 3.18 2.613 5.76 5.794 5.76.032 0 .08-.004.111-.005-1.257 1.002-2.837 1.605-4.566 1.605-.795 0-1.436.645-1.436 1.44 0 .795.512 1.44 1.308 1.44 5.646 0 10.107-4.594 10.107-10.24v-.004C24.914 2.576 22.47 0 19.29 0zM5.798 0C2.617 0 .1 2.579.1 5.76c0 3.18 2.61 5.76 5.792 5.76.031 0 .078-.004.11-.005-1.258 1.002-2.838 1.605-4.567 1.605-.795 0-1.436.645-1.436 1.44C0 15.355.52 16 1.315 16c5.647 0 10.116-4.594 10.116-10.24v-.004C11.43 2.576 8.978 0 5.798 0z"/>
  </svg>
))

export default QuoteIcon 